import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Events, NavParams } from "ionic-angular";
import { PainSiteService } from "../../pain-site-card/pain-site.service";
import { woundNotes } from "../new-wound-site-service";
import { NewWoundService } from "../new-wound.service";

@Component({
  selector: "new-wound-notes",
  templateUrl: "new-wound-notes.html",
})
export class NewWoundNotesComponent {
  notes: any;
  config: any;
  cardData: any;
  private woundNotes: woundNotes;
  data: any;
  painService: PainSiteService;
  constructor(
    private newWoundService: NewWoundService,
    public translatePipe: TranslateService,
    public events: Events,
    params: NavParams
  ) {
    let data = params.data;
    this.config = data.config;
    this.cardData = data.cardData;
    this.woundNotes = { woundCareTreatment: "", additionalNotes: "" };
    this.painService = this.newWoundService.getPainService();
  }

  ngOnInit(): void {
    for (let i = 0; i < this.config.tabs.length; i++) {
      if (this.config.tabs[i].notes) {
        this.notes = this.config.tabs[i].notes;
      }
    }

    this.newWoundService.getCurrentPointData().subscribe((currentWound) => {
      if (currentWound) {
        this.data = currentWound;
        if (currentWound.notes) {
          this.woundNotes.woundCareTreatment =
            currentWound.notes.woundCareTreatment;
          this.woundNotes.additionalNotes = currentWound.notes.additionalNotes;
        }
      }
    });

    this.events.subscribe("data:sent", (data) => {
      this.cardData = data;
    });
  }

  updateCardData() {
    if (this.data) {
      this.data.notes = this.woundNotes;
      this.newWoundService.setCurrentPointData(this.data);
    }
  }

  validateChar(data, field) {}
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/new-wound-site-card/new-wound-notes/new-wound-notes.ts